export const CHANGE_CURRENT_PAGE = 'PostmarkSettings/CHANGE_CURRENT_PAGE'
export const CREATE_POSTMARK_SETTING = 'PostmarkSettings/CREATE_POSTMARK_SETTING'
export const FETCH_POSTMARK_SETTINGS_LIST = 'PostmarkSettings/FETCH_POSTMARK_SETTINGS_LIST'
export const FETCH_POSTMARK_SETTINGS_FOR_OPTIONS = 'PostmarkSettings/FETCH_POSTMARK_SETTINGS_FOR_OPTIONS'
export const REMOVE_POSTMARK_SETTING = 'PostmarkSettings/REMOVE_POSTMARK_SETTING'
export const UPDATE_POSTMARK_SETTING = 'PostmarkSettings/UPDATE_POSTMARK_SETTING'
